import React, { FC } from 'react'
import { HashRouter as Router, Switch, Route } from 'react-router-dom'

import TemplateList from '../template/pages/TemplateList'
import TemplateEditor from '../template/pages/TemplateEditor'
import { TemplatesContainer } from '../template/styles'
import { useDimensions } from '../hooks/useDimensions'
import { CONTAINER_DEDUCTION } from '../constants'

interface TemplatesRouterProps {
    urlParams: string[]
}

const TemplatesRouter: FC<TemplatesRouterProps> = (props: TemplatesRouterProps) => {
    const dimensions = useDimensions({ height: CONTAINER_DEDUCTION })

    const innerDimensions = React.useMemo(() => {
        return { height: dimensions.height }
    }, [dimensions])

    return (
        <Router basename="/config/annotations-templates">
            <Switch>
                <Route path="/new">
                    <TemplateEditor {...props} />
                </Route>
                <Route path="/:templateId">
                    <TemplateEditor {...props} />
                </Route>
                <TemplatesContainer height={innerDimensions.height}>
                    <Route path="/">
                        <TemplateList />
                    </Route>
                </TemplatesContainer>
            </Switch>
        </Router>
    )
}

export default TemplatesRouter
